<div class="flex items-center justify-center min-h-screen w-full bg-base-200 p-4">
  <div class="card w-full max-w-md lg:max-w-2xl bg-base-100 shadow-xl">
    <div class="card-body items-center text-center">
      <i class="pi pi-exclamation-triangle text-error !text-6xl mb-4"></i>
      <h2 class="card-title text-xl lg:text-2xl font-bold text-error">{{ message | translate }}</h2>
    </div>
  </div>
</div>
